module.exports = __webpack_public_path__ + "media/assets/images/category/OfficeFun@2x-7a5aece9ecd2b16522b1298b425eef56.png";